/**
 * Red de seguridad para pestañas viejas.
 *
 * Los archivos de build llevan hash en el nombre (main.b8af7c59.js). Cuando se
 * publica un deploy, los archivos anteriores desaparecen del servidor: si una
 * pestaña que lleva horas abierta intenta cargar un chunk que ya no existe,
 * revienta con "Loading chunk failed" y la pantalla se queda rota.
 *
 * Aquí lo detectamos y recargamos para tomar el build nuevo. El sello de tiempo
 * en sessionStorage evita un bucle de recargas si el error viene de otra cosa.
 */
const FLAG = 'psycle:chunk-reload-at';
const MIN_MS_BETWEEN_RELOADS = 30 * 1000;

const CHUNK_ERROR = /Loading (CSS )?chunk .* failed|ChunkLoadError|Failed to fetch dynamically imported module/i;

function recover(message) {
  if (!message || !CHUNK_ERROR.test(String(message))) return;

  const last = Number(sessionStorage.getItem(FLAG) || 0);
  if (Date.now() - last < MIN_MS_BETWEEN_RELOADS) return;

  sessionStorage.setItem(FLAG, String(Date.now()));
  window.location.reload();
}

export default function reloadOnChunkError() {
  window.addEventListener('error', (e) => recover(e?.message || e?.error?.message));
  window.addEventListener('unhandledrejection', (e) => recover(e?.reason?.message || e?.reason));
}